<template>
    <navBar :title="title" :actions="actions" :home="home" @actionClick="actionClick"/>
</template>
  
<script>
  
import navBar from '@/components/ui/navbars/navbar.vue';

export default {
    props: {
        title: {
            type: String,
            default: 'Ares - Host booking'
        },
        home:{
            type: Boolean,
            default: false,
        },
        actions: {
            type: Array,
            default: function() {return [];}
        }        
    },
    components: {
        navBar,
    },
    methods: {
        actionClick(action){
            this.$emit('actionClick', action);
        }
    } 
}
  
</script>
  